import { jsx } from "react/jsx-runtime";
import { getFirstCharacter, usePresence } from "@tldraw/editor";
function DefaultPeopleMenuAvatar({ userId }) {
  const presence = usePresence(userId);
  if (!presence) return null;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "tlui-people-menu__avatar",
      style: {
        backgroundColor: presence.color
      },
      children: getFirstCharacter(presence.userName ?? "")
    }
  );
}
export {
  DefaultPeopleMenuAvatar
};
//# sourceMappingURL=DefaultPeopleMenuAvatar.mjs.map
